import { CommunicationStateInterface } from "./types";
import Notification from "@/types/app/notifications";
import Schedule from "@/types/app/schedules";
import NotificationInterface from "@/types/app/notifications";

export default {
  setModalNewNotificationState(state: CommunicationStateInterface, show: boolean) {
    state.modalNewNotification = show;
  },
  setModalNotificationState(state: CommunicationStateInterface, show: boolean) {
    state.modalNotification = show;
  },
  setNotificationState(
    state: CommunicationStateInterface,
    notification: Notification
  ) {
    state.notification = notification;
  },
  setNotificationsState(
    state: CommunicationStateInterface,
    notifications: NotificationInterface[]
  ) {
    state.notifications = notifications;
  },  
  setNotificationSent(state: CommunicationStateInterface, show: boolean) {
    state.notificationSent = show;
  },
  setModalNotificationDelete(state: CommunicationStateInterface, show: boolean) {
    state.modalNotificationDelete = show;
  },
  setScheduleState(state: CommunicationStateInterface, schedule: Schedule) {
    state.schedule = schedule;
  },
  setModalScheduleState(state: CommunicationStateInterface, show: boolean) {
    state.modalSchedule = show;
  },
  setScheduleFeedbackModalState(state: CommunicationStateInterface, show: boolean) {
    state.scheduleFeedbackModal = show;
  },
  setModalNewEmailNotificationState(state: CommunicationStateInterface, show: boolean) {
    state.modalNewEmailNotification = show;
  },
  setModalEmailNotificationState(state: CommunicationStateInterface, show: boolean) {
    state.modalEmailNotification = show;
  },
  setEmailNotificationState(
    state: CommunicationStateInterface,
    notification: Notification
  ) {
    state.emailNotification = notification;
  },
  setEmailNotificationsState(
    state: CommunicationStateInterface,
    notifications: NotificationInterface[]
  ) {
    state.emailNotifications = notifications;
  },
  setEmailNotificationSent(state: CommunicationStateInterface, show: boolean) {
    state.emailNotificationSent = show;
  },
  setModalEmailNotificationDelete(state: CommunicationStateInterface, show: boolean) {
    state.modalEmailNotificationDelete = show;
  },

  clearAllData(state: CommunicationStateInterface){
    state.emailNotifications = [];
    state.notifications = [];
    state.schedules = [];
  }
};
